import { ActivityIndicatorComponent, ComponentsService, ScreenHelperService } from 'library-explorer';
import { Component, HostListener, NgZone } from '@angular/core';
import { IonApp, IonRouterOutlet, Platform } from '@ionic/angular/standalone';
import { register } from 'swiper/element/bundle';
import { addIcons } from 'ionicons';
import * as ionIcons from 'ionicons/icons';
import { DataService } from './services/data.service';
import { StatusBar, Style } from '@capacitor/status-bar';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CartService } from './services/cart.service';


register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrl: 'app.component.scss',
  standalone: true,
  imports: [IonApp, IonRouterOutlet, ActivityIndicatorComponent],
})
export class AppComponent {
  constructor(private platform: Platform, private cartService: CartService, private screenHelperService: ScreenHelperService, private router: Router, private zone: NgZone, private components: ComponentsService, private dataService: DataService) {
    this.initializeApp();
  }

  initializeApp() {
    addIcons(ionIcons);

    this.dataService.loadGroupedFooterPages();
    this.screenHelperService.onResize(this.platform.width());
    this.loadListeners();
  }

  private loadListeners() {
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.zone.run(() => {
        const slug = event.url.replace(`${environment.urlScheme}://`, 'native/');

        if (slug) {
          this.components.closeBrowser();
          this.cartService.init();
          this.router.navigateByUrl(slug);
        }
      });
    });
  }
  // Screen Size Handler
  @HostListener('window:resize', ['$event'])
  private onResize(event: any) {
    this.screenHelperService.onResize(event.target.innerWidth);
  }

  private async setMobileEdgeToEdgeFix() {
    // app.component.ts
    await StatusBar.setStyle({ style: Style.Light }); // or Style.Dark
    await StatusBar.setOverlaysWebView({ overlay: true }); // content goes under status bar

    // (Optional) transparent status bar on Android:
    await StatusBar.setBackgroundColor({ color: '#00000000' });
  }
}
